import load from "../img/prosess.gif"
import {Link} from "react-router-dom"

function Load() {
  return (
    <>
      <div className="Load">
        {/* <img width={'80%'} src={load} /> */}
        <Link to="/load" className="load"></Link>
      </div>
    </>
  );
}

export default Load;
